import {
  BooleanFlagEntry,
  EnumFlagEntry,
  FlagRecord,
} from './types';

const readBoolean = (record: FlagRecord, field: string): boolean =>
  !!(record && (record as Record<string, unknown>)[field]);

const readString = (
  record: FlagRecord,
  field: string,
): string | null => {
  const value = record?.[field as keyof typeof record];
  return typeof value === 'string' && value.length > 0 ? value : null;
};

export type EffectiveBoolean = {
  global: boolean;
  therapist: boolean;
  effective: boolean;
  /**
   * True when the therapist control should be disabled because the global
   * setting fully determines the effective value (OR-merge with global on).
   */
  locked: boolean;
};

export const computeEffectiveBoolean = (
  entry: BooleanFlagEntry,
  globalConfig: FlagRecord,
  therapistRecord?: FlagRecord,
): EffectiveBoolean => {
  const global = readBoolean(globalConfig, entry.globalField);
  const therapist =
    !!entry.therapistField &&
    readBoolean(therapistRecord, entry.therapistField);

  if (entry.merge === 'globalOnly') {
    return { global, therapist: false, effective: global, locked: false };
  }

  return {
    global,
    therapist,
    effective: global || therapist,
    locked: global,
  };
};

export type EffectiveEnum = {
  global: string;
  therapist: string | null;
  effective: string;
  locked: false;
};

export const computeEffectiveEnum = (
  entry: EnumFlagEntry,
  globalConfig: FlagRecord,
  therapistRecord?: FlagRecord,
): EffectiveEnum => {
  const global = readString(globalConfig, entry.globalField) ?? entry.defaultOption;
  const therapist = entry.therapistField
    ? readString(therapistRecord, entry.therapistField)
    : null;
  return {
    global,
    therapist,
    effective: therapist ?? global,
    locked: false,
  };
};
